// Admin sign-in. Shows whichever methods this deployment supports — Auth0
// (this dashboard's own tenant, see auth.tsx) and/or the admin bootstrap key.

import { useState } from 'react';
import { useAuth } from '../auth';
import { Logo } from '../components/Logo';
import { ThemeToggle } from '../components/ThemeToggle';
import { ErrorMessage, Spinner } from '../components/ui';

export default function LoginPage() {
  const { config, sessionConfig, loginWithAuth0, loginWithAdminKey } = useAuth();
  const [adminKey, setAdminKey] = useState('');
  const [showKeyForm, setShowKeyForm] = useState(false);
  const [busy, setBusy] = useState(false);
  const [error, setError] = useState<unknown>(null);

  const submitKey = async (event: React.FormEvent) => {
    event.preventDefault();
    setBusy(true);
    setError(null);
    try {
      await loginWithAdminKey(adminKey);
    } catch (err) {
      setError(err instanceof Error ? new Error('That admin key was not accepted.') : err);
    } finally {
      setBusy(false);
    }
  };

  const auth0Enabled = !!sessionConfig?.enabled;

  return (
    <div className="auth-screen">
      <div style={{ position: 'fixed', top: 12, right: 14 }}>
        <ThemeToggle />
      </div>
      <div className="auth-card">
        <div className="auth-logo">
          <Logo height={34} />
        </div>
        <p className="muted center" style={{ marginBottom: '1.5rem' }}>
          Agent-first container deployment. Admin access only.
        </p>

        <ErrorMessage error={error} />

        {auth0Enabled ? (
          <button type="button" className="btn btn-primary btn-block" onClick={loginWithAuth0}>
            Sign in
          </button>
        ) : null}

        {auth0Enabled ? <div className="divider">or</div> : null}

        {showKeyForm || !auth0Enabled ? (
          <form onSubmit={submitKey}>
            <div className="field">
              <label htmlFor="adminkey">Admin key</label>
              <input
                id="adminkey"
                type="password"
                value={adminKey}
                onChange={(e) => setAdminKey(e.target.value)}
                placeholder="the deployment's admin bootstrap key"
                autoFocus
              />
            </div>
            <button type="submit" className="btn btn-primary btn-block" disabled={busy || !adminKey.trim()}>
              {busy ? <Spinner /> : 'Continue with admin key'}
            </button>
          </form>
        ) : (
          <button type="button" className="btn btn-ghost btn-block" onClick={() => setShowKeyForm(true)}>
            Use the admin key
          </button>
        )}

        <p className="faint small center" style={{ marginTop: '1.5rem', marginBottom: 0 }}>
          {config?.env === 'local' ? 'Local deployment' : null}
        </p>
      </div>
    </div>
  );
}
